import { render, staticRenderFns } from "./CalculadoraItp.vue?vue&type=template&id=79ac50c4&scoped=true&"
import script from "./CalculadoraItp.vue?vue&type=script&lang=js&"
export * from "./CalculadoraItp.vue?vue&type=script&lang=js&"
import style0 from "./CalculadoraItp.vue?vue&type=style&index=0&id=79ac50c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ac50c4",
  null
  
)

export default component.exports